import React from "react";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import { Spring } from "react-spring";
import Loading from "../../components/Loading/Loading";
import HeaderComponent from "../../components/Header";
import {
  slotActions,
  appointmentActions,
  sessionActions,
  counsellorActions,
  authActions,
  alertActions,
} from "../../store/actions";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import image1 from "../../static/images/1.svg";
import image2 from "../../static/images/2.svg";
import image3 from "../../static/images/3new.svg";
import image4 from "../../static/images/3.svg";
import blogIcon from "../../static/images/carbon_blog.svg";
import feedbackImage from "../../static/images/feedback.svg";
import Footer from "../../components/Footer/footer";
import Swal from "sweetalert2";
import notfound from "../../static/images/notfound.png";
import allowcamera from "../../static/images/allowcamera.png";
import { history } from "../../helpers";
import "../../static/css/styles.css";
import "../../components/Modal/modal.css";
import { constants } from "../../Constants";
import EditAppointmentModal from "../../components/EditAppointmentModal";
import FeedbackModal from "../../components/Feedback/feedback";
import {
  counsellorDashboard,
  patientDashConst,
} from "../../helpers/ConstantID";
const styles = {
  customWidth: {
    maxWidth: 500,
  },
  noMaxWidth: {
    maxWidth: "none",
  },
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownValue: "0",
      selectedDate: "",
      normalState: true,
      searchedState: false,
      slot_id: "",
      session: [],
      searchedTimeSlots: [],
      counsellor_id: "",
      toggleChecked: null,
      role: sessionStorage.getItem("role"),
      appointments: [],
      appointmentsChanged: false,
      counsellorStatus: null,
      counsellorPopup: false,
      allowedPermissions: false,
      showAppointmentModal: false,
      showEditModal: false,
      resourceError: "",
      appointmentId: "",
      selected_time: "",
      selected_date: "",
      joinDisable: false,
      showFeedback: false,
    };
    this.textInput = React.createRef();
    this.JoinSession = this.JoinSession.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.deleteTimeSlot = this.deleteTimeSlot.bind(this);
    this.showAvailableModal = this.showAvailableModal.bind(this);
    this.onAppointmentModalClose = this.onAppointmentModalClose.bind(this);
    this.handleRedirection = this.handleRedirection.bind(this);
  }

  componentWillMount() {
    const project_id = localStorage.getItem("project_id");
    this.props.getUserData();
    this.props.getAppointments(project_id);
    if (this.props.user !== undefined && this.props.user !== null) {
      if (this.props.user.role === 1) {
        history.replace("/home");
      }
    }
  }

  componentDidMount() {
    if (localStorage.getItem("session_ended")) {
      localStorage.removeItem("session_ended");
      window.location.reload(true);
    }
    this.browserDetcet();
    this.props.getCounsellorStatus();
  }

  componentWillReceiveProps(nextProps) {
    const project_id = localStorage.getItem("project_id");

    if (this.state.appointmentsChanged) {
      this.props.getAppointments(project_id);
    }
    this.setState({
      appointments: nextProps.appointments,
      appointmentsChanged: false,
    });

    if (
      nextProps.counsellorStatus &&
      nextProps.counsellorStatus !== undefined
    ) {
      this.setState({
        toggleChecked: nextProps.counsellorStatus,
      });
    }
    if (nextProps && nextProps.updateStatus) {
      this.setState({ showEditModal: !nextProps.updateStatus });
      this.props.resetUpdateAppointmentStatus();
      this.props.getAppointments(project_id);
    }
  }

  componentWillUnmount() {
    this.props.clearAlertActions();
  }

  createAppointmentPage = () => {
    this.setState({
      showAppointmentModal: true,
    });
  };
  onChangeTime = (e) => {
    this.setState({ selected_time: e.target.value });
  };
  onDateChange = (date) => {
    this.setState({ selected_date: date });
  };
  onAppointmentModalClose() {
    this.setState({ showAppointmentModal: false });
  }
  editAppointment = (e) => {
    const { appointmentId, selected_date, selected_time } = this.state;
    const date = `${moment(selected_date).format(
      "YYYY-MM-DD"
    )} ${selected_time}`;

    const slotTime = moment(date, "YYYY-MM-DD hh:mm:ss").utc().format();
    this.props.updateAppointments(appointmentId, slotTime);
  };

  sessionDetailsHandler(sessionID) {
    history.push(`/appointment-details/${sessionID}`)
  }

  handleChange = (value) => {
    const filterAppointments = this.state.appointments.filter(function (obj) {
      return obj.id !== value;
    });

    Swal.fire({
      title: "Are you sure?",
      text: "You want to Cancel your appointment!",
      type: "warning",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: "#36A692",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.value) {
        this.props.cancelAppointment(value);
        this.setState({
          appointments: filterAppointments,
          appointmentsChanged: true,
        });

        Swal.fire(
          "Saaya Health",
          "Your Appointment has been cancelled!",
          "success"
        );
      } else {
      }
    });
  };

  technicalFeedback = () => {
    this.setState({ showFeedback: !this.state.showFeedback });
  };

  openUrl = () => {
    window.open(constants.COUNSELLOR_FEEDBACK_URL, "_blank");
    this.setState({ showFeedback: false });
  };

  redirectFaq = () => {
    history.push(`/faq`);
  };

  redirectBlogs = () => {
    window.open(`https://saayahealth.com/blog`);
  };

  openNotes = () => {
    history.push("/note");
  };
  redirectTaskeen = () => {
    Swal.fire({
      title: "You will now be redirected!",
      text: "You will now be redirected to our partners at Taskeen where you can find more information about your wellbeing!",
      type: "warning",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: "#36A692",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.value) {
        window.open("http://taskeen.org/en/learn/distress/");
      }
    });
  };

  /* Check Browser and OS */
  browserDetcet = () => {
    const BrowserDetect = {
      init: function () {
        this.browser =
          this.searchString(this.dataBrowser) || "An unknown browser";
        this.version =
          this.searchVersion(navigator.userAgent) ||
          this.searchVersion(navigator.appVersion) ||
          "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
      },
      searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;
          this.versionSearchString = data[i].versionSearch || data[i].identity;
          if (dataString) {
            if (dataString.indexOf(data[i].subString) != -1)
              return data[i].identity;
          } else if (dataProp) return data[i].identity;
        }
      },
      searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) return;
        return parseFloat(
          dataString.substring(index + this.versionSearchString.length + 1)
        );
      },
      dataBrowser: [
        {
          string: navigator.userAgent,
          subString: "Chrome",
          identity: "Chrome",
        },
        {
          string: navigator.userAgent,
          subString: "OmniWeb",
          versionSearch: "OmniWeb/",
          identity: "OmniWeb",
        },
        {
          string: navigator.vendor,
          subString: "Apple",
          identity: "Safari",
          versionSearch: "Version",
        },
        {
          prop: window.opera,
          identity: "Opera",
          versionSearch: "Version",
        },
        {
          string: navigator.vendor,
          subString: "iCab",
          identity: "iCab",
        },
        {
          string: navigator.vendor,
          subString: "KDE",
          identity: "Konqueror",
        },
        {
          string: navigator.userAgent,
          subString: "Firefox",
          identity: "Firefox",
        },
        {
          string: navigator.vendor,
          subString: "Camino",
          identity: "Camino",
        },
        {
          // for newer Netscapes (6+)
          string: navigator.userAgent,
          subString: "Netscape",
          identity: "Netscape",
        },
        {
          string: navigator.userAgent,
          subString: "MSIE",
          identity: "Explorer",
          versionSearch: "MSIE",
        },
        {
          string: navigator.userAgent,
          subString: "Gecko",
          identity: "Mozilla",
          versionSearch: "rv",
        },
        {
          // for older Netscapes (4-)
          string: navigator.userAgent,
          subString: "Mozilla",
          identity: "Netscape",
          versionSearch: "Mozilla",
        },
      ],
      dataOS: [
        {
          string: navigator.platform,
          subString: "Win",
          identity: "Windows",
        },
        {
          string: navigator.platform,
          subString: "Mac",
          identity: "Mac",
        },
        {
          string: navigator.userAgent,
          subString: "iPhone",
          identity: "IOS",
        },
        {
          string: navigator.platform,
          subString: "iPad",
          identity: "IOS",
        },
        {
          string: navigator.platform,
          subString: "Linux",
          identity: "Linux",
        },
      ],
    };

    BrowserDetect.init();

    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    const os = BrowserDetect.OS;
    const browser = BrowserDetect.browser + BrowserDetect.version;

    this.setState({
      os,
    });
    this.setState({
      browser,
    });
    if (isMobile.any() == null || undefined) {
      let device = "PC";
      this.setState({
        device: "PC",
      });
    } else {
      let device = isMobile.any();
      this.setState({
        device: device[0],
      });
    }
  };
  showAvailableModal = () => {
    let projectsDiv = "";

    const isAllProjectsSelected = this.state.toggleChecked.every(item => item.status === true);
    const selectAllCheckbox = `<div>
      <input type="checkbox" id="selectAllCheckbox" ${isAllProjectsSelected ? "checked" : ""}>
      <label for="selectAllCheckbox" id="selectAllLabel">${isAllProjectsSelected ? "Unselect All" : "Select All"}</label>
    </div>`;

    if (
      this.props.user &&
      this.props.user.projects &&
      this.props.user.projects.length > 0
    ) {
      projectsDiv += this.props.user.projects.map((p) => {
        const obj = this.state.toggleChecked.find((item) => item.project_id === p.id);
        const status = obj ? obj.status : false;

        return `<div class='project-list-item'>
			
        <input type="checkbox" ${status ? `checked` : ""
          } class="hidden popup-project-checkbox" name='${p.name}' id='project-${p.id
          }'> 
			</input>
		<label class="popup-project-label my-label" for='project-${p.id}' id='label-project-${p.id}'>${p.name
          } <span class="hidden popup-project-icon"><i class="fas fa-check"></i></span></label>
		
        </div>`;
      });

      Swal.fire({
        title: constants.MARK_PROJECT_AVAILABILITY,
        html: `<p class='margin10'> Select / Unselect projects and click OK to continue </p>
        ${selectAllCheckbox}
			<div class='project-list-container'>${[projectsDiv].join("").replace(/,/g, "")} </div>`,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "rgba(48, 86, 167, 0.87)",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancel",
        confirmButtonText: "Ok",
        onOpen: function () {
          Swal.getPopup()
            .querySelector(".swal2-cancel")
            .setAttribute("id", "btnCancelUpdateProject");
          Swal.getPopup()
            .querySelector(".swal2-confirm")
            .setAttribute("id", "btnConfirmUpdateProject");

          const selectAllCheckbox = Swal.getPopup().querySelector("#selectAllCheckbox");
          const projectCheckboxes = Swal.getPopup().querySelectorAll(".popup-project-checkbox");

          // Event listener for the "Select All / Unselect All" checkbox
          selectAllCheckbox.addEventListener("change", (event) => {
            const isChecked = event.target.checked;
            projectCheckboxes.forEach((checkbox) => {
              checkbox.checked = isChecked;
            });
            document.getElementById("selectAllLabel").innerText = isChecked ? "Unselect All" : "Select All";
          });

          // Update "Select All" checkbox if individual checkboxes are changed
          projectCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
              const allChecked = Array.from(projectCheckboxes).every(projectBox => projectBox.checked);
              selectAllCheckbox.checked = allChecked;
              document.getElementById("selectAllLabel").innerText = allChecked ? "Unselect All" : "Select All";
            });
          });
        },
        preConfirm: () => {
          const projects = this.props.user.projects;
          let checked = [];
          projects.forEach((p) => {
            var obj = {};
            obj["checked"] = Swal.getPopup().querySelector(
              "#project-" + p.id
            ).checked;
            obj["id"] = p.id;
            checked.push(obj);
          });
          return checked;
        },
      }).then((result) => {
        if (!!result.value) {
          // result will show all the checked projects

          let payload = result.value.map((item) => {
            return { project_id: item.id, is_available: item.checked };
          });
          this.props.setCounsellorStatus(payload);
        }
      });
    } else Swal.fire(constants.UNASSGNED_COUNSELLOR_MSG, "", "error");
  };
  /* Check Browser and OS */
  checkPermissions = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true,
      });
      /* use the stream */
      this.setState({ allowedPermissions: true });
      return { success: true, msg: "" };
    } catch (err) {
      console.log("catch :", err);
      this.setState({ allowedPermissions: false, resourceError: err });
      return { success: false, msg: err };
    }
  };
  JoinSession(appointment_id, schedule) {
    if (!moment(schedule).isBefore(moment().add("10", "m"))) {
      return false;
    }

    if (this.state.joinDisable) {
      return;
    }
    this.setState({ joinDisable: true });
    this.btn.setAttribute("disabled", "disabled");

    this.checkPermissions().then((response) => {
      let msg = "";
      if (!response.success) {
        if (
          response.msg.toString().indexOf("Could not start video source") > -1
        )
          msg = constants.REOURCE_IN_USE_ERROR;
        else if (response.msg.toString().indexOf("device not found") > -1)
          msg = constants.RESEOURCE_NOT_FOUND_ERROR;
        else if (
          response.msg.toString().indexOf("Permission denied") > -1 ||
          response.msg.toString().indexOf("NotAllowedError") > -1 ||
          response.msg.toString().indexOf("The object can not be found here") >
          -1
        )
          msg = constants.UNSUPPORTED_MSG_BODY;

        Swal.fire({
          title: constants.UNSUPPORTED_MSG_TITLE,
          text: msg !== "" ? msg : constants.SESSION_GENERAL_ERROR,
          //onClose: this.redirectHome()
        });
        this.setState({ joinDisable: false });
        return false;
      } else {
        const appointmentId = appointment_id;
        const OT = window.OT.checkSystemRequirements();
        const os = this.state.os;
        const browser = this.state.browser;
        const device = this.state.device;

        if (OT === 0) {
          Swal.fire({
            title: "Please update your browser!",
            text: "Please update your browser.Your browser version is old which can cause problem..",
            confirmButtonColor: "#36A692",

            imageUrl:
              "https://publicize.co/wp-content/uploads/2017/08/dfghj.jpg",
            imageWidth: 300,
            imageHeight: 200,
            imageAlt: "camera not found",
          });
        }
        const { appointments, openTokService } = this.props;

        openTokService(appointmentId, os, browser, device);

        const appointmentDetails = appointments && appointments.find(app => app.id === appointmentId);
        if (appointmentDetails) {
          const { patient_name, counsellor_name, date_time } = appointmentDetails;
          localStorage.setItem('appointmentDetails', JSON.stringify({ patient_name, counsellor_name, date_time }));
        }

        function videoError(e) {
          const error = e.toString();
          if (error.includes("NotFoundError") === true) {
            Swal.fire({
              title: "Camera Or Microphone Not Found!",
              text: "Please connect a camera and microphone and try again to join session.",
              confirmButtonColor: "#36A692",

              imageUrl: notfound,
              imageWidth: 500,
              imageHeight: 250,
              imageAlt: "camera not found",
            });
          }

          if (error.includes("Invalid constraint") === true) {
            Swal.fire({
              title: "Camera Not Found!",
              text: "Please connect a camera and try again to join sessions.",
              confirmButtonColor: "#36A692",

              imageUrl: notfound,
              imageWidth: 500,
              imageHeight: 250,
              imageAlt: "camera not found",
            });
          }

          if (error.includes("NotAllowedError") === true) {
            Swal.fire({
              title: "You have blocked camera and Microphone!",
              confirmButtonColor: "#36A692",

              text: "Please Follow above instruction to enable camera and microphone and then you can try again to join session.",
              imageUrl: allowcamera,
              imageWidth: 400,
              imageHeight: 300,
              imageAlt: "camera and Microphone blocked",
            });
          }
          this.setState({ joinDisable: false });
        }
      }
    });
    this.btn.removeAttribute("disabled");
  }

  editSession = (appointmentId) => {
    const { appointments, selected_date, selected_time } = this.state;
    let appointment = "";
    if (appointments && appointmentId) {
      appointment = appointments.filter((a) => {
        return a.id === appointmentId;
      })[0];
    }
    let updated_date = moment(appointment.date_time).format("MMMM D, YYYY").toLocaleString("en-US", { hour: "numeric", })
    let updated_time = moment(appointment.date_time).format("HH:mm:ss").toLocaleString("en-US", { hour: "numeric", })
    if (selected_date === "" || selected_date === null || selected_date === undefined) {
      this.setState({ selected_date: updated_date })
    }
    if (selected_time === "" || selected_time === null || selected_time === undefined) {
      this.setState({ selected_time: updated_time })
    }
    this.setState({
      showEditModal: true,
      appointmentId
    });
  };
  onCloseEditModal = () => {
    this.setState({ showEditModal: false });
  };

  deleteTimeSlot(e) {
    const { dispatch } = this.props;
    dispatch(slotActions.deleteTimeSlot(e.target.value));
  }

  handleRedirection = (type) => {
    const _null = "null"
    if (
      this.props.user &&
      this.props.user.projects &&
      this.props.user.projects.length > 0
    ) {
      this.setState({ showAppointmentModal: false });
      switch (type) {
        case "view": {
          history.push("/counselor/slots");
          break;
        }
        case "register": {
          history.push(`/counselor/slotpicker`);
          break;
        }
        case "create": {
          history.push("/counsellor/appointments");
          break;
        }
        default:
          break;
      }
    } else Swal.fire(constants.UNASSGNED_COUNSELLOR_MSG, "", "error");
  };

  render() {
    const { user } = this.props;
    const dateObj = new Date();
    const { showAppointmentModal, showEditModal, appointments } = this.state;
    if (
      this.props.appointments !== undefined &&
      this.state.appointments !== undefined &&
      !this.props.loading
    ) {
      return (
        <div className={this.state.showAppointmentModal === true || this.state.showEditModal === true ? "sh-layout-modal-open" : "sh-layout"}>
          <HeaderComponent />
          <div className="sh-counsellor-dash-comp sh-gnrl-width">
            {/* Welcome Note */}
            <div className="sh-gnrl-welcome-note">
              <h2
                className="sh-gnrl-welcome"
                id={counsellorDashboard.sh_cd_counsellor_name}
              >
                Welcome {user && user.full_name && user.full_name.toUpperCase()}
              </h2>
            </div>

            {/* Session Div */}
            <div className="sh-gnrl-container">
              <div className="sh-gnrl-cont-header">
                <h3 className="sh-gnrl-ch-heading">
                  {constants.YOUR_NEXT_SESSION_TXT}
                </h3>
              </div>
              {appointments && appointments.length < 1 ? (
                <div className="sh-gnrl-cont-content">
                  <div className="sh-gnrl-cc-row">
                    <div className="sh-gnrl-col-1">
                      <span className="sh-gnrl-cchc-main-title">
                        {constants.NO_APPOINTMENTS_TXT}
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.state.appointments && this.state.appointments.length > 0 && (
                <div className="sh-gnrl-cont-content">
                  {/* Header for counsellor */}
                  <div className="sh-gnrl-cc-row">
                    <div className="sh-gnrl-col-1 sh-mble-col-2">
                      <span className="sh-gnrl-cchc-main-head">
                        {constants.PATIENT_NAME_TXT}
                      </span>
                    </div>
                    <div className="sh-gnrl-col-2 sh-mble-col-2">
                      <span className="sh-gnrl-cchc-main-head">
                        {constants.WHEN_TXT}
                      </span>
                    </div>
                    <div className="sh-gnrl-col-1 sh-mble-col-1">
                      <span className="sh-gnrl-cchc-main-head">
                        <i className="fa fa-bars"></i>
                      </span>
                    </div>
                  </div>
                  {this.props.appointments &&
                    this.state.appointments.map((v, i) => {
                      return (
                        <div className="sh-gnrl-cc-row">
                          <div className="sh-gnrl-col-1 sh-mble-col-2">
                            <span
                              className="sh-gnrl-cchc-main-title"
                              id={`${patientDashConst.sh_pt_app_name}${i}`}
                            >{`${v.patient_name} (${v.project_name})`}</span>
                          </div>
                          <div className="sh-gnrl-col-2 sh-mble-col-2">
                            <span
                              className="sh-gnrl-cchc-main-title"
                              id={`${patientDashConst.sh_pt_app_time}${i}`}
                            >
                              {moment(v.date_time)
                                .format("ddd DD MMM YYYY hh:mm:ss A")
                                .toLocaleString("en-US", {
                                  hour: "numeric",
                                  hour12: true,
                                })}
                            </span>
                          </div>
                          <div className="sh-gnrl-col-1 sh-mble-col-1">
                            <div className="sh-gnrl-btn-container">
                              {!moment(v.date_time).isBefore(
                                moment().add("10", "m")
                              ) ? (
                                <button
                                  type="button"
                                  className={`sh-btn-edit sh-gnrl-btn-session `}
                                  onClick={() => this.editSession(v.id)}
                                  id={counsellorDashboard.sh_cd_edit_btn}
                                >
                                  <span className="sh-text-icon">
                                    {constants.EDIT_TXT}
                                  </span>
                                  <span className="icon"></span>
                                </button>
                              ) : null}

                              {moment(v.date_time).isBefore(
                                moment().add("24", "h")
                              ) ? (
                                <Tooltip
                                  title={
                                    moment(v.date_time).isBefore(
                                      moment().add("10", "m")
                                    )
                                      ? ""
                                      : `You will be able to join this session 10 minutes before the start time. Current time of your device is ${moment(
                                        new Date()
                                      ).toString()}. If you wish to change or cancel the session please email us at contact@saayahealth.com`
                                  }
                                  disableFocusListener
                                  disableTouchListener
                                  classes={{ tooltip: styles.customWidth }}
                                >
                                  <button
                                    type="button"
                                    className="sh-btn-join sh-gnrl-btn-session"
                                    id={counsellorDashboard.sh_cd_join_btn}
                                    ref={(btn) => {
                                      this.btn = btn;
                                    }}
                                    disabled={this.state.joinDisable}
                                    onClick={() =>
                                      this.JoinSession(v.id, v.date_time)
                                    }
                                  >
                                    <span className="sh-text-icon">
                                      {constants.JOIN_TXT}
                                    </span>
                                    <span className="icon"></span>
                                  </button>
                                </Tooltip>
                              ) : (
                                <button
                                  className="sh-btn-cancel sh-gnrl-btn-session"
                                  id={counsellorDashboard.sh_cd_cancel_btn}
                                  value={v.id}
                                  onClick={() => this.handleChange(v.id)}
                                >
                                  <span className="sh-text-icon">
                                    {constants.CANCEL_TXT}
                                  </span>
                                  <span className="icon"></span>
                                </button>
                              )}
                              <button
                                className="sh-btn-detail sh-gnrl-btn-session"
                                id={counsellorDashboard.sh_cd_detail_btn}
                                value={v.id}
                                onClick={() => this.sessionDetailsHandler(v.id)}
                              >
                                <span className="sh-text-icon">
                                  {constants.DETAILS_TXT}
                                </span>
                                <span className="icon"></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>

            {/* Mian Dashboard */}
            <div className="sh-main-dash-container">
              <div className="sh-mdc-col-1">
                <div
                  className="sh-mdc-inner"
                  id={counsellorDashboard.sh_cd_learn_about_wellbeing}
                  onClick={this.showAvailableModal}
                >
                  <div className="sh-mdc-image">
                    <img src={image3} alt="faq icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.MANAGE_AVAILABILITY_TXT}</span>
                  </div>
                </div>
              </div>
              <div className="sh-mdc-col-1">
                <div
                  className="sh-mdc-inner"
                  id={counsellorDashboard.sh_cd_schedule_session}
                  onClick={this.createAppointmentPage}
                >
                  <div className="sh-mdc-image">
                    <img src={image1} alt="scheduling icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.SCHEDULE_SESSION_TEXT}</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1">
                <div
                  className="sh-mdc-inner"
                  id={counsellorDashboard.sh_cd_your_notes}
                  onClick={this.openNotes}
                >
                  <div className="sh-mdc-image">
                    <img src={image2} id="imgNotes" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.NOTES_TEXT}</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1">
                <div
                  className="sh-mdc-inner"
                  id={counsellorDashboard.sh_cd_faq}
                  onClick={this.redirectFaq}
                >
                  <div className="sh-mdc-image">
                    <img src={image4} alt="wellbeing icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.FAQ_TEXT}</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1 mt-20">
                <div className="sh-mdc-inner" onClick={this.technicalFeedback}>
                  <div className="sh-mdc-image">
                    <img src={feedbackImage} alt="feedback icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>Feedback</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1 mt-20">
                <div
                  className="sh-mdc-inner"
                  onClick={this.redirectBlogs}
                >
                  <div className="sh-mdc-image">
                    <img src={blogIcon} alt="blog_icons" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.VIEW_BLOGS_TXT}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.showFeedback ? (
            <FeedbackModal
              feedbackModal={this.technicalFeedback}
              openUrl={this.openUrl}
              FEEDBACK_HEADING={constants.COUNSELLOR_FEEDBACK_HEADING}
              FEEDBACK_TEXT={constants.COUNSELLOR_FEEDBACK_TEXT}
              FEEDBACK_BTN_TEXT={constants.COUNSELLOR_FEEDBACK_BTN_TEXT}
            />
          ) : (
            ""
          )}
          {showAppointmentModal ? (
            <div className="modal-info">
              <div
                className="modal-react counsellor-apt-modal"
                id="modal"
                tabIndex={0}
                onBlur={this.onAppointmentModalClose}
                style={{
                  width: "518px !important",
                  margin: "134px auto",
                  backgroundColor: "#fff",
                }}
              >
                <span
                  onClick={this.onAppointmentModalClose}
                  className="close-button topright"
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </span>
                <div className="content">
                  {/* </header> */}
                  <table className="table borderless table-responsive w-100 d-block d-md-table">
                    <tbody className="text-center tableBody">
                      <tr>
                        <td colSpan={3} className="td-no-border">
                          <img
                            className="card-img-top pt-2 pb-3 pl-5 pr-5"
                            src={image1}
                            width="150px"
                            height="150px"
                            alt="slot icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3} className="td-no-border">
                          <div className="swal2-title">
                            {constants.MANAGE_SCHEDULE_TXT}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3} className="td-no-border">
                          <button
                            type="button"
                            className="swal2-confirm modal-buttons"
                            aria-label=""
                            id="btnViewSlots"
                            onClick={() => this.handleRedirection("view")}
                            style={{
                              padding: "0.400em 1em !important",
                              display: "inline-block",
                              backgroundColor: "rgb(54, 166, 146)",
                            }}
                          >
                            {constants.VIEW_SLOTS_TXT}
                          </button>
                          <button
                            type="button"
                            className="swal2-confirm modal-buttons"
                            aria-label=""
                            id="btnRegisterSlots"
                            onClick={() => this.handleRedirection("register")}
                            style={{
                              padding: "0.400em 1em !important",
                              display: "inline-block",
                              backgroundColor: "rgb(54, 166, 146)",
                              borderLeftColor: "rgb(54, 166, 146)",
                              borderRightColor: "rgb(54, 166, 146)",
                            }}
                          >
                            {constants.REGISTER_SLOTS}
                          </button>
                          <button
                            type="button"
                            className="swal2-confirm modal-buttons"
                            aria-label=""
                            id="btnCreateAppointment"
                            onClick={() => this.handleRedirection("create")}
                            style={{
                              padding: "0.400em 1em !important",
                              display: "inline-block",
                              backgroundColor: "rgb(54, 166, 146)",
                              borderLeftColor: "rgb(54, 166, 146)",
                              borderRightColor: "rgb(54, 166, 146)",
                            }}
                          >
                            {constants.CREATE_APPOINTMENT_TXT}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {showEditModal ? (
            <EditAppointmentModal
              appointmentId={this.state.appointmentId}
              appointments={this.props.appointments}
              onDateChange={this.onDateChange}
              onTimeChange={this.onChangeTime}
              onCloseModal={this.onCloseEditModal}
              selected_time={this.state.selected_time}
              selected_date={this.state.selected_date}
              editAppointment={this.editAppointment}
            />
          ) : (
            ""
          )}
          <Footer />
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}

function mapStateToProps(state) {
  const { session, auth, alert } = state;
  const { appointments, loading, updateStatus } = state.appointments;
  const { counsellorStatus } = state.counsellorStatus;
  const { user } = auth;
  return {
    user,
    alert,
    appointments,
    session,
    counsellorStatus,
    loading,
    updateStatus,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAppointments: (id) => {
      dispatch(appointmentActions.getAppointments(id));
    },
    getUserData: () => {
      dispatch(authActions.getUserData());
    },
    cancelAppointment: (value) => {
      dispatch(appointmentActions.cancelAppointment(value));
    },
    openTokService: (appointmentId, os, browser, device) => {
      dispatch(
        sessionActions.OpenTokService(appointmentId, os, browser, device)
      );
    },
    setCounsellorStatus: (status) => {
      dispatch(appointmentActions.setCounsellorStatus(status));
    },
    getCounsellorStatus: () => {
      dispatch(counsellorActions.getCounsellorStatus());
    },
    updateAppointments: (appointmentId, date_time) => {
      dispatch(appointmentActions.updateAppointments(appointmentId, date_time));
    },
    resetUpdateAppointmentStatus: () => {
      dispatch(appointmentActions.resetUpdateAppointmentStatus());
    },
    clearAlertActions: () => {
      dispatch(alertActions.clear());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/screens/CounsellorHome/index.js